module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e19b41b321fe53ee7158064aa419959d.png";